export default "__VITE_ASSET__Bge98X9y__"